import EventBus from 'diagram-js/lib/core/EventBus';
import { GuideBox } from 'diagram-js/lib/model';
import { ModelingUtil } from '@ispm/shared/bpmn-io/modeling-util';
import { CommandType, EventType } from '@ispm/shared/bpmn-io/bpmn-js';
import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import * as _ from 'lodash';
import { OverlayType } from '@ispm/shared/bpmn-io/overlay-types';
import { isANode } from '@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/command-interceptor-utils';

export class GuideBoxOverlayBehaviour extends CommandInterceptor {

  constructor(protected eventBus: EventBus, private overlays) {
    super(eventBus);
    super.postExecuted([CommandType.SHAPE_REPLACE], isANode(this.handleGuideBoxShapeReplace.bind(this)));

    eventBus.on(EventType.NODE_UPDATED, (event) => {
      if(event.node){
        event.context = { node: event.node};
        this.addGuideBoxOverlay(event);
      }
    });

    eventBus.on([EventType.SHAPE_ADDED], (event) => {
      event.context = { node: event.element};
      if (event.element.businessObject.markedToBeRendered) {
        this.addGuideBoxOverlay(event);
      }
    });


    eventBus.on(EventType.GUIDEBOX_DATA_REMOVED, (event) => {
      this.overlays.remove({ element: event.node.id, type: OverlayType.guidedBoxOverlay});
    });
  }

  addIconOverlay(node) {
    const note: GuideBox = ModelingUtil.getGuideBox(node);
    const noteClass = (note.automatically.toString() === 'true') ? 'mandatory-guidebox-icon' : 'non-mandatory-guidebox-icon';
    const htmlElementId = `guidebox_icon_${node.id}`;
    this.overlays.add(node.id, OverlayType.guidedBoxOverlay, {
      position: {
        top: -1,
        right: 0
      },
      html: `<i class="guidebox-icon-wrapper guidebox-icon icon__info info-icon ${noteClass}" id="${htmlElementId}"></i>`
    });
  }

  handleGuideBoxShapeReplace(event) {
    event.context.node = event.context.newShape;
    this.overlays.remove({ element: event.context.node.id, type: OverlayType.guidedBoxOverlay});
    this.addGuideBoxOverlay(event);
  }


  private addGuideBoxOverlay(event) {
    if (!_.isEmpty(ModelingUtil.getGuideBox(event.context.node))) {
      this.addIconOverlay(event.context.node);
      this.eventBus.fire(EventType.GUIDEBOX_OVERLAY_ADDED, {
        elementId: event.context.node.id
      });
    }
  }
}


GuideBoxOverlayBehaviour.$inject = ['eventBus', 'overlays'];
